var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 5.67188H21.1875V4.96875C21.1875 3.80564 20.2412 2.85938 19.0781 2.85938H3.51562C2.35252 2.85938 1.40625 3.80564 1.40625 4.96875V16.9219H0.703125C0.314812 16.9219 0 17.2367 0 17.625V19.0312C0 20.1944 0.946266 21.1406 2.10938 21.1406H21.8906C23.0537 21.1406 24 20.1944 24 19.0312V7.78125C24 6.61814 23.0537 5.67188 21.8906 5.67188ZM2.8125 4.96875C2.8125 4.58105 3.12792 4.26562 3.51562 4.26562H19.0781C19.4658 4.26562 19.7812 4.58105 19.7812 4.96875V5.67188H16.2656C15.1025 5.67188 14.1562 6.61814 14.1562 7.78125V16.9219H2.8125V4.96875ZM1.40625 19.0312V18.3281H14.1562V19.0312C14.1562 19.2777 14.1991 19.5143 14.2772 19.7344H2.10938C1.72167 19.7344 1.40625 19.419 1.40625 19.0312ZM22.5938 19.0312C22.5938 19.419 22.2783 19.7344 21.8906 19.7344H16.2656C15.8779 19.7344 15.5625 19.419 15.5625 19.0312V7.78125C15.5625 7.39355 15.8779 7.07812 16.2656 7.07812H21.8906C22.2783 7.07812 22.5938 7.39355 22.5938 7.78125V19.0312Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7812 16.9219H18.375C17.9867 16.9219 17.6719 17.2367 17.6719 17.625C17.6719 18.0133 17.9867 18.3281 18.375 18.3281H19.7812C20.1696 18.3281 20.4844 18.0133 20.4844 17.625C20.4844 17.2367 20.1696 16.9219 19.7812 16.9219Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 9.89062C19.4665 9.89062 19.7812 9.57583 19.7812 9.1875C19.7812 8.79917 19.4665 8.48438 19.0781 8.48438C18.6898 8.48438 18.375 8.79917 18.375 9.1875C18.375 9.57583 18.6898 9.89062 19.0781 9.89062Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/Platform.1828d91eaaa35bd1c0f084c41ced4d6e.svg";
export { ForwardRef as ReactComponent };